import * as React from 'react'

import dynamic from 'next/dynamic'

import { i18n } from '@thg-commerce/enterprise-core'
import { WishlistButtonType } from '@thg-commerce/enterprise-components/Product/src/WishlistButton/WishlistButton'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'

import {
  ProductAlternativesWrapper,
  WishlistButtonWrapper,
  ProductComingSoonTitle,
} from './styles'
import { useProductPage } from '../../context'
import { WishlistButtonRendererProps } from '../../renderers/WishlistButtonRenderer/WishlistButtonRenderer'

const WishlistButtonRenderer = dynamic<WishlistButtonRendererProps>(() =>
  import('../../renderers/WishlistButtonRenderer').then(
    (mod) => mod.WishlistButtonRenderer,
  ),
)

export const ProductAlternatives = () => {
  const { selectedVariant } = useProductPage()
  const i18nText = {
    productComingSoonText: i18n('product.alternatives.text'),
  }
  const theme = useTheme()

  const wishlistButtonStyle =
    theme.pageTheme?.productOptions.addToBasketContainer.addToWishlistButton
      ?.style || undefined

  return (
    <ProductAlternativesWrapper>
      <ProductComingSoonTitle>
        {i18nText.productComingSoonText}
      </ProductComingSoonTitle>
      <WishlistButtonWrapper>
        <WishlistButtonRenderer
          selectedVariant={selectedVariant}
          buttonType={WishlistButtonType.TEXT}
          buttonStyle={wishlistButtonStyle}
        />
      </WishlistButtonWrapper>
    </ProductAlternativesWrapper>
  )
}
